import { useEffect, useMemo, useState } from "react";
import { Link, useHistory } from "react-router-dom";
//---------------------------------------------------------------------
import Resize from "src/components/common/resize";
import magnifierImg from "src/img/magnifier.png";
import { laborCategorys, laborShopsCategorys } from "src/components/projects/workInstruction/workInstructionForm";
import { useMyStore } from "src/components/main/mainStore";
import {
    onlyUnique, 
    round, 
    getDatefromWeekNum, 
    weeknum, 
    getTimeStamp, 
    myAxios, 
    MyFormData, 
    defaultEmptyDateTime, 
    simpleStatusColorCode, 
    restDayProjectHashKey, 
    boolAndReducer, 
    pipelineOptions, 
    weekIndexes,
    appTitle
} from "src/components/common/functions";
//---------------------------------------------------------------------
export default function Calendar({ tabTitle }){
    //--------------------------------------------------------------------------------------------
    // if(isDevMode) console.log("all");
    //--------------------------------------------------------------------------------------------
    const user = useMyStore(state => state.user);
    const allWorkLogs = useMyStore(state => state.calendarWorkLogs);
    const setWorkLogs = useMyStore(state => state.setCalendarWorkLogs);
    const weeks = useMyStore(state => state.calendarWeeks);
    const setWeeks = useMyStore(state => state.setCalendarWeeks);
    const week = useMyStore((state) => state.calendarWeek);
    const setWeek = useMyStore((state) => state.setCalendarWeek);
    //---------------------------------------------------------------------
    const history = useHistory();
    const path = history.location.pathname;
    const path1 = decodeURIComponent(path.split("/")[1] ?? "");
    const path2 = decodeURIComponent(path.split("/")[2] ?? "");
    //---------------------------------------------------------------------
    const [updateDateTime, setUpdateDateTime] = useState({
        "Weeks": weeks.updatedAt === null?getTimeStamp():weeks.updatedAt, 
        "Work Logs": allWorkLogs.updatedAt === null?getTimeStamp():allWorkLogs.updatedAt, 
    });
    //---------------------------------------------------------------------
    const [showLoading, setShowLoading] = useState(false);
    const [showHours, setShowHours] = useState(false);
    const [showTimes, setShowTimes] = useState(false);
    const [laborCategory, setLaborCategory] = useState("All");
    const [category, setCategory] = useState("All");
    const [status, setStatus] = useState("All");
    const [filterWords, setFilterWords] = useState("");
    //---------------------------------------------------------------------
    const getHours = workLog => {
        if(workLog.workLogStatus === "Created"){
            return({
                portal: 0,
                withoutTravel: 0
            });
        }
        const travelStartTime = new Date(workLog.travelStartTime.replace(/-/g, "/"));
        const workStartTime = new Date(workLog.workStartTime.replace(/-/g, "/"));
        const workEndTime = new Date(workLog.workEndTime.replace(/-/g, "/"));
        const travelEndTime = new Date(workLog.travelEndTime.replace(/-/g, "/"));
        const workHours = (workEndTime - workStartTime) / 3600000;
        const travel = (travelEndTime - travelStartTime) / 3600000;
        if(travelEndTime.toString() === "Invalid Date"){
            return({
                portal: "Invalid Date",
                withoutTravel: "Invalid Date"
            });
        }
        return({
            portal: round(travel, 2),
            withoutTravel: round(workHours, 2),
        })
    }
    //---------------------------------------------------------------------
    const workLogs = useMemo(() => allWorkLogs[path2] ?? [], [allWorkLogs, path2]);
    const extendedWorkLogs = useMemo(() => workLogs.map(workLog => ({
        ...workLog, 
        travelStartTime: workLog.travelStartTime.replace(/-/g, "/"),
        workStartTime: workLog.workStartTime.replace(/-/g, "/"),
        workEndTime: workLog.workEndTime.replace(/-/g, "/"),
        travelEndTime: workLog.travelEndTime.replace(/-/g, "/"),
        startTime: workLog.startTime.replace(/-/g, "/"),
        endTime: workLog.endTime.replace(/-/g, "/")
    })).map(workLog => ({...workLog, 
        ...getHours(workLog),
        projectName: workLog.projectNumber + " - " + workLog.organizationName + " - " + workLog.clientProjectNumber,
        userName: workLog.userName?.replace(/ {2}/g, " ") ?? "unknown"
    })), [workLogs]);
    const filteredWorkLogs = useMemo(() => extendedWorkLogs.filter(workLog =>
        ((status !== "All")?
            (
                (status === "Unsubmitted")?
                workLog.workLogStatus === "Created"
                    :
                    (status === "Billed")?
                    workLog.billed === "Yes"
                        :
                        workLog.workLogStatus === status
            )
            :
            true
        ) && 
        workLog.laborCategory !== "Images" && 
        workLog.projectHashKey !== restDayProjectHashKey && 
        (laborCategory !== "All"?workLog.laborCategory === laborCategory:true) &&
        (category !== "All"?workLog.category === category:true) &&
        filterWords.toLowerCase().split(" ").map(f => JSON.stringify(
            [workLog.userName, workLog.projectName, workLog.truckNumber]
        ).toLowerCase().indexOf(f) > -1).reduce(boolAndReducer, true)
    ), [category, extendedWorkLogs, filterWords, laborCategory, status]);
    //---------------------------------------------------------------------
    useEffect(() => {
        if(week === null) setWeek(path2);
      }, [week, setWeek, path2]);
    //---------------------------------------------------------------------
    useEffect(() => {
        if(week === null || updateDateTime["Weeks"] === weeks.updatedAt) return;
        const controller = new AbortController();
        let isMounted = true;
        const getData = async () => {
            //---------------------------------------------------------------------
            setShowLoading(true);
            const resWeeks = await myAxios("payroll/readLaborWorkLogsWeek.php", undefined, undefined, controller.signal);
            if(!isMounted) return;
            setShowLoading(false);
            if(!resWeeks) return;
            //---------------------------------------------------------------------
            const dateArray = [];
            const dateMin = new Date(resWeeks.data.minTime.replace(/-/g, "/"));
            const dateMax = new Date(resWeeks.data.maxTime.replace(/-/g, "/"));
            while(dateMin < dateMax){
                dateArray.push(weeknum(dateMax));
                dateMax.setDate(dateMax.getDate() - 7);
            }
            if(!dateArray.includes(weeknum(dateMin))){
                dateArray.push(weeknum(dateMin));
            }
            setWeeks(dateArray, updateDateTime["Weeks"]);
            if(!dateArray.includes(week)){
                const thisWeek = weeknum(new Date());
                setWeek(thisWeek);
                history.replace(`/${path1}/${thisWeek}`);
            }
        }
        getData();
        return () => {
            isMounted = false;
            controller.abort();
        }
    }, [history, path1, setWeeks, updateDateTime, week, setWeek, weeks.updatedAt])
    useEffect(() => {
        if(weeks.updatedAt !== updateDateTime["Weeks"]) return;
        let isMounted = true;
        const controller = new AbortController();
        const getData = async () => {
            //---------------------------------------------------------------------
            const formData = new MyFormData();
            formData.append("weekStart", getDatefromWeekNum(week, 0));
            formData.append("weekEnd", getDatefromWeekNum(week, 6));
            //---------------------------------------------------------------------
            setShowLoading(true);
            const res = await myAxios("invoice/readLaborWorkLogs.php", formData, undefined, controller.signal);
            if(!isMounted) return;
            setShowLoading(false);
            if(!res) return;
            //---------------------------------------------------------------------
            setWorkLogs(
                week, 
                res.data, 
                updateDateTime["Work Logs"]
            );
        }
        if(!allWorkLogs[week] || allWorkLogs.updatedAt !== updateDateTime["Work Logs"]) getData();
        return () => {
            isMounted = false;
            controller.abort();
        }
    }, [allWorkLogs, setWorkLogs, updateDateTime, week, weeks.updatedAt])
    useEffect(() => {
        document.title = tabTitle;
        return () => {
            document.title = appTitle;
        };
    }, [tabTitle]);
    //---------------------------------------------------------------------
    return (
        <div className = "cssTab">
            <div className = "cssHeader" style = {{background: user.userTheme}}>
                <span>
                    <Resize/>
                    {path1}
                    <button
                        type = "button"
                        data-toggle = "tooltip"
                        title = {`Refreshed on ${Object.values(updateDateTime)[0]}.`}
                        className = "btn btn-primary ml-3"
                        onClick = {() => {
                            const timeStamp = getTimeStamp();
                            setUpdateDateTime(Object.fromEntries(Object.keys(updateDateTime).map(key => [key, timeStamp])));
                        }}
                    >
                        ↻
                    </button>
                </span>
                <span>
                    <input
                        id = "searchBar"
                        className = "form-control w-auto"
                        type = "text"
                        value = {filterWords}
                        onChange = {e => {
                            setFilterWords(e.currentTarget.value.toLowerCase());
                        }}
                    />
                    <img alt = "" src = {magnifierImg}/>
                </span>
                <span className = "d-flex align-items-center">
                    <label htmlFor = "status" className = "mb-0">Status:</label>
                    <select
                        id = "status"
                        className = "form-control w-auto ml-2"
                        value = {status}
                        onChange = {e => setStatus(e.currentTarget.value)}
                    >
                        <option>All</option>
                        <option>Unsubmitted</option>
                        <option>Submitted</option>
                        <option>Approved</option>
                        <option>Rejected</option>
                        <option>Billed</option>
                    </select>
                </span>
                <span className = "d-flex align-items-center">
                    <label htmlFor = "showTimes" className = "mb-0">Show Times:</label>
                    <input
                        type = "checkbox"
                        id = "showTimes"
                        className = "cssCheckBox ml-2"
                        checked = {showTimes}
                        onChange = {e => {
                            if(e.currentTarget.checked){
                                setShowTimes(true);
                            }else{
                                setShowTimes(false);
                            }
                        }}                                                                                                                                                                                                                 
                    />
                </span>
                <span className = "d-flex align-items-center">
                    <label htmlFor = "showHours" className = "mb-0">Show Hours:</label>
                    <input
                        type = "checkbox"
                        id = "showHours"
                        className = "cssCheckBox ml-2"
                        checked = {showHours}
                        onChange = {e => {
                            if(e.currentTarget.checked){
                                setShowHours(true);
                            }else{
                                setShowHours(false);
                            }
                        }}
                    />
                </span>
                <span className = "d-flex align-items-center">
                    <label htmlFor = "category" className = "mb-0">
                        Calendar:
                    </label>
                    <select
                        id = "category"
                        className = "form-control w-auto ml-2"
                        value = {category}
                        onChange = {e => {
                            setCategory(e.currentTarget.value);
                            setLaborCategory("All");
                        }}
                    >
                        <option>All</option>
                        {Object.keys(pipelineOptions).map((thisPipeline, thisPipelineIndex) => <option key = {thisPipelineIndex}>{thisPipeline}</option>)}
                    </select>
                </span>
                <span className = "d-flex align-items-center">
                    <label htmlFor = "laborCategory" className = "mb-0">
                        Labor Category:
                    </label>
                    <select
                        id = "laborCategory"
                        className = "form-control w-auto ml-2"
                        value = {laborCategory}
                        onChange = {e => {
                            setLaborCategory(e.currentTarget.value);
                        }}
                    >
                        <option>All</option>
                        <optgroup label = "Billable Work">
                        {laborCategorys.map((x, xi) => <option key = {xi}>{x}</option>)}
                        </optgroup>
                        <optgroup label = "Shop Work">
                        {laborShopsCategorys.map((x, xi) => <option key = {xi}>{x}</option>)}
                        </optgroup>
                        <optgroup label = "Others">
                            <option>Images</option>
                        </optgroup>
                    </select>
                </span>
                <span className = "d-flex align-items-center">
                    <label htmlFor = "week" className = "mb-0">
                        Week:
                    </label>
                    <select
                        id = "week"
                        className = "form-control w-auto ml-2"
                        value = {path2}
                        onChange = {e => {
                            setWeek(e.currentTarget.value);
                            history.replace(`/${path1}/${e.currentTarget.value}`);
                        }}
                    >
                        {weeks.data.map((wk, key) => <option key = {key}>{wk}</option>)}
                    </select>
                </span>
            </div>
            {showLoading?<div className = "cssContent pb10"><div className = "cssLoading">Loading...</div></div>:
            !filteredWorkLogs.length?<div className = "cssContent pb10"><div className = "cssLoading">Empty</div></div>:
            <div>
                <div className = "text-center font-weight-bold my-3">
                    <span className = "font-weight-bold mr-4">Status Color Code</span>
                    <span style = {{color: "red", padding: 10, border: "1px solid black", borderRight: "none"}}>Unsubmitted ({filteredWorkLogs.filter(v => v.workLogStatus === "Created").length})</span>
                    <span style = {{color: "purple", padding: 10, borderTop: "1px solid black", borderBottom: "1px solid black"}}>Submitted ({filteredWorkLogs.filter(v => v.workLogStatus === "Submitted").length})</span>
                    <span style = {{color: "green", padding: 10, borderTop: "1px solid black", borderBottom: "1px solid black"}}>Approved ({filteredWorkLogs.filter(v => v.workLogStatus === "Approved").length})</span>
                    <span style = {{color: "pink", padding: 10, borderTop: "1px solid black", borderBottom: "1px solid black"}}>Billed ({filteredWorkLogs.filter(v => v.billed === "Yes").length})</span>
                    <span style = {{color: "gray", padding: 10, border: "1px solid black", borderLeft: "none"}}>Rejected ({filteredWorkLogs.filter(v => v.workLogStatus === "Rejected").length})</span>
                </div>
                <div className = "overflow-visible">
                    <table className = "table">
                        <thead>
                            <tr className = "stickyHeader">
                                <th>Monday ({path2?getDatefromWeekNum(path2, 0):""})</th>                    
                                <th>Tuesday ({path2?getDatefromWeekNum(path2, 1):""})</th>
                                <th>Wednesday ({path2?getDatefromWeekNum(path2, 2):""})</th>
                                <th>Thursday ({path2?getDatefromWeekNum(path2, 3):""})</th>
                                <th>Friday ({path2?getDatefromWeekNum(path2, 4):""})</th>
                                <th>Saturday ({path2?getDatefromWeekNum(path2, 5):""})</th>
                                <th>Sunday ({path2?getDatefromWeekNum(path2, 6):""})</th>
                            </tr>
                            </thead>
                            <tbody>
                            {<tr>
                                {weekIndexes.map((num, numi) => <td key = {numi} className = "align-top">
                                    <ul>
                                        {filteredWorkLogs.filter(vx => (new Date(vx.startTime.substring(0, 10).replace(/-/g, "/"))).getDay() === num).map(vx => vx.workInstructionHashKey).filter(onlyUnique)
                                        .map(vv => filteredWorkLogs.filter(vx => (vx.workInstructionHashKey === vv)))
                                        .map((vv, vvi) => 
                                        <li className = "border rounded p-2 mb-4" key = {vvi}>
                                            <Link className = "font-weight-bold" to = {`/Projects/${vv[0].projectHashKey}/WorkInstructions/${vv[0].workInstructionHashKey}`}>
                                                <div>
                                                    {vv[0].projectNumber} - {vv[0].organizationName} - {vv[0].clientProjectNumber}
                                                </div>
                                                <span className = "text-dark">
                                                    {
                                                        vv[0].startTime.substring(0, 10) === vv[0].endTime.substring(0, 10)?
                                                            vv[0].startTime.substring(11, 16) === "00:00" && vv[0].endTime.substring(11, 16) === "00:00"?
                                                            ``
                                                            :
                                                            `${vv[0].startTime.substring(11, 16)} ~ ${vv[0].endTime.substring(11, 16)}`
                                                        :
                                                            vv[0].startTime.substring(11, 16) === "00:00" && vv[0].endTime.substring(11, 16) === "00:00"?
                                                            `Overnight`
                                                            :
                                                            `${vv[0].startTime.substring(11, 16)} ~ ${vv[0].endTime.substring(0, 16)}`
                                                    }
                                                        {vv[0].billed === "Yes"?<span style = {{color: "pink"}}>&nbsp;Billed</span>:<></>}
                                                </span>
                                            </Link>
                                            <ul>{vv.map((vvv, vvvi) => 
                                                <li key = {vvvi}>
                                                    <Link to = {`/Projects/${vvv.projectHashKey}/WorkInstructions/${vvv.workInstructionHashKey}/WorkLogs/${vvv.workLogHashKey}`}>
                                                        <span className= "font-weight-bold" style = {{color:simpleStatusColorCode[vvv.workLogStatus]}}>
                                                            <span className = "text-secondary mr-2">{vvv.laborCategory}</span>
                                                            {vvv.userName}
                                                            <span className = "text-secondary ml-2">{vvv.truckNumber}</span>
                                                        </span>
                                                    </Link>
                                                    <ul>
                                                        {showTimes?<>
                                                        <li>
                                                            <span className = "font-weight-bold mr-2">Travel Start:</span>
                                                            {vvv.travelStartTime !== defaultEmptyDateTime?(
                                                                (new Date(vvv.travelStartTime.substring(0, 10).replace(/-/g, "/"))).getDay() === num?
                                                                vvv.travelStartTime.substring(10, 16):
                                                                vvv.travelStartTime.substring(0, 16)
                                                            ):""}
                                                        </li>
                                                        <li>
                                                            <span className = "font-weight-bold mr-2">Work Start:</span>
                                                            {vvv.workStartTime !== defaultEmptyDateTime?(
                                                                (new Date(vvv.workStartTime.substring(0, 10).replace(/-/g, "/"))).getDay() === num?
                                                                vvv.workStartTime.substring(10, 16):
                                                                vvv.workStartTime.substring(0, 16)
                                                            ):""}
                                                        </li>
                                                        <li> 
                                                            <span className = "font-weight-bold mr-2">Work End:</span>
                                                            {vvv.workEndTime !== defaultEmptyDateTime?(
                                                                (new Date(vvv.workEndTime.substring(0, 10).replace(/-/g, "/"))).getDay() === num?
                                                                vvv.workEndTime.substring(10, 16):
                                                                vvv.workEndTime.substring(0, 16)
                                                            ):""}
                                                        </li>
                                                        <li>
                                                            <span className = "font-weight-bold mr-2">Travel End:</span>
                                                            {vvv.travelEndTime !== defaultEmptyDateTime?(
                                                                (new Date(vvv.travelEndTime.substring(0, 10).replace(/-/g, "/"))).getDay() === num?
                                                                vvv.travelEndTime.substring(10, 16):
                                                                vvv.travelEndTime.substring(0, 16)
                                                            ):""}
                                                        </li>
                                                        </>:<></>}
                                                        {showHours?<>
                                                        {vvv.workLogStatus !== "Created"?<>
                                                            <li>
                                                                <span className = "font-weight-bold mr-2">Work + Travel:</span>
                                                                {vvv.portal}
                                                            </li>
                                                            <li>
                                                                <span className = "font-weight-bold mr-2">Work:</span>
                                                                {vvv.withoutTravel}
                                                            </li>

                                                        </>:<></>}
                                                        </>:<></>}
                                                    </ul>
                                                </li>)}
                                            </ul>   
                                        </li>)}
                                    </ul>
                                </td>)}
                            </tr>}
                        </tbody>
                    </table>
                </div>
            </div>}
        </div>
    )
}